// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1278":"4-auth-msal","57798":"4-feat-protobuf-request","73810":"4-feat-protobuf-scenario-type","83660":"2-polyfill-idle","96288":"4-feat-protobuf-client-properties"}[chunkId] || chunkId) + ".js";
};